/**
 * Normalizes CMS video poster URLs for next/image and Mux poster slots.
 * Skips data URIs (unsupported by next/image) and normalizes protocol-relative URLs to https.
 */
export const resolveVideoPosterUrl = thumbnail => {
  if (!thumbnail) {
    return undefined;
  }

  const src =
    typeof thumbnail === 'string'
      ? thumbnail
      : thumbnail.filename || thumbnail.src;

  if (!src || typeof src !== 'string') {
    return undefined;
  }

  if (src.startsWith('data:')) {
    return undefined;
  }

  if (src.startsWith('//')) {
    return `https:${src}`;
  }

  return src;
};
